export default __webpack_public_path__ + "static/media/149.ba5b857e.jpg";